<template>
    
           
  <div class="row mb-3">
    <div class="col-6">
      <h5>Available Popup Elements</h5>

      <draggable
        :list="available"
        class="list-group h-100 p-2 bg-light"
        draggable=".item"
        group="a"
      >
        <div
          class="list-group-item item"
          v-for="popupelement in available"
          :key="popupelement.id"
        >
          {{ popupelement.name }} <span class="alert-secondary rounded-pill px-1"> ID: {{ popupelement.id }} </span>  <i class="fa fa-arrows float-right mt-1"></i>
        </div>


      </draggable>
    </div>

    <div class="col-6">
      <h5>Selected Popup Elements</h5>

      <draggable :list="selected" class="list-group h-100  p-2 bg-light" draggable=".item" group="a" @change="updatePopupelementNav">
        <div
          class="list-group-item item"
          v-for="popupelement in selected"
          :key="popupelement.id"      
        >
          {{ popupelement.name }} <span class="alert-secondary rounded-pill px-1"> ID: {{ popupelement.id }} </span> <i class="fa fa-arrows float-right mt-1"></i>
        </div>

      </draggable>
    </div>

  </div>

    
</template>

<script>

import axios from 'axios';

export default {
    mounted(){
        this.getPopupelementNavs();
    },
  components: {
    draggable
  },
  props: [
    'id'
  ],
  data() {
    return {
      navId: this.id,
      available: [],
      selected: []
    };
  },
  methods: {
    getPopupelementNavs: function() {
    

        var vm = this;

        axios.get('/admin/formelement-nav/'+this.navId+'/list-formelements').then(response => {

          var selected = Object.values(response.data.selected_popupelements);
          var available = Object.values(response.data.available_popupelements);

          vm.selected = selected;
          vm.available = available;
          
        }).catch(() => console.warn('Oh. Something went wrong. getPopupelementNavs'));

    },
    updatePopupelementNav: function() {
       
        var vm = this;

        var popupelement_ids = $.map(vm.selected, function(o) { return o["id"]; })

        axios.post('/admin/formelement-nav/'+this.navId+'/sync-formelements',{popupelements:popupelement_ids}).then(response => {

          Vue.nextTick(function(){
            vm.getPopupelementNavs();
          });


        }).catch(() => console.warn('Oh. Something went wrong. updatePopupelementNav'));
    
    },
  }
};

</script>